import { createFileRoute } from '@tanstack/react-router'
import { KelolaStaff } from '../../../../components/KelolaStaff'

export const Route = createFileRoute('/platform/desa/$desaId/staff')({
  component: () => {
    const { desaId } = Route.useParams()
    return <KelolaStaff desaId={desaId} />
  },
})
